import { render, staticRenderFns } from "./DefaultChart.vue?vue&type=template&id=2f3255a5&"
import script from "./DefaultChart.vue?vue&type=script&lang=js&"
export * from "./DefaultChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports